import { Component } from 'opus-angular-seed-core';

import fileTextIcon from 'lucide-static/icons/file-text.svg';
import fileSpreadsheetIcon from 'lucide-static/icons/file-spreadsheet.svg';
import fileImageIcon from 'lucide-static/icons/file-image.svg';
import fileVideoIcon from 'lucide-static/icons/file-video.svg';
import fileArchiveIcon from 'lucide-static/icons/file-archive.svg';
import fileIcon from 'lucide-static/icons/file.svg';
import fileChartPieIcon from 'lucide-static/icons/file-chart-pie.svg';
import trashIcon from 'lucide-static/icons/trash-2.svg';
import downloadIcon from 'lucide-static/icons/download.svg';
import xIcon from 'lucide-static/icons/x.svg';
import infoIcon from 'lucide-static/icons/info.svg';
import plusIcon from 'lucide-static/icons/plus.svg';


const EXTENSION_ICON_MAP = {
    pdf: fileTextIcon,
    doc: fileTextIcon,
    docx: fileTextIcon,
    ppt: fileChartPieIcon,
    pptx: fileChartPieIcon,
    xls: fileSpreadsheetIcon,
    xlsx: fileSpreadsheetIcon,
    csv: fileSpreadsheetIcon,
    jpg: fileImageIcon,
    jpeg: fileImageIcon,
    gif: fileImageIcon,
    webp: fileImageIcon,
    svg: fileImageIcon,
    tiff: fileImageIcon,
    bmp: fileImageIcon,
    png: fileImageIcon,
    heic: fileImageIcon,
    heif: fileImageIcon,
    mp4: fileVideoIcon,
    zip: fileArchiveIcon,
    epub: fileTextIcon,
    info: infoIcon,
    plus: plusIcon,
    trash: trashIcon
};

const DEFAULT_ICON = fileIcon;

export { trashIcon, downloadIcon, xIcon };

export function getFileIconSvg (filename) {
    if (!filename) {
        return DEFAULT_ICON;
    }
    const extension = filename.split('.').pop().toLowerCase();
    return EXTENSION_ICON_MAP[extension] || DEFAULT_ICON;
}

@Component({
    bindings: {
        filename: '<',
        size: '@'
    },
    template: `
        <span class="file-icon" ng-class="vm.sizeClass" ng-bind-html="vm.iconHtml"></span>
    `
})
export default class {
    constructor ($sce) {
        this.$sce = $sce;
    }
    $onInit () {
        this.updateIcon();
    }
    $onChanges () {
        this.updateIcon();
    }
    updateIcon () {
        const rawSvg = getFileIconSvg(this.filename);
        this.sizeClass = this.size === 'lg' ? 'file-icon--lg' : 'file-icon--sm';
        this.iconHtml = this.$sce.trustAsHtml(rawSvg);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/file/fileIcon/index.js